<template>
  <v-data-table
    :headers="visualizarPontosMedalha ? headers : headersSemPontos"
    :items="perguntasRespondidas"
    class="elevation-1"
    hide-default-footer
    disable-pagination
    item-key="perguntaMunicipioId"
    v-if="!isSala"
  >
    <template v-slot:item="props">
      <tr :class="'evidenciar'">
        <td>{{ props.item.nome }}</td>
        <td>{{ props.item.numero }}</td>
        <td>
          <div>
            <div>{{ props.item.texto }}</div>
          </div>
        </td>
        <td>{{ props.item.pontos }}</td>
        <td width="300px">
          <v-form
            ref="file"
            lazy-validation
            v-if="
              isFullAdmin ||
              !isSala ||
              (isSala &&
                JSON.parse(config.visualizaEixosIds || '[]').includes(
                  props.item.eixoId
                ))
            "
          >
            <v-file-input
              v-if="
                isFullAdmin ||
                (groupsConfig.enviarRespondidas && config.enviarRespondidas)
              "
              :rules="rules"
              multiple
              label="Selecione Arquivos de Evidência"
              v-model="props.item.arquivos"
            >
            </v-file-input>
          </v-form>
        </td>
        <td>
          <template
            v-if="
              isFullAdmin ||
              !isSala ||
              (isSala &&
                JSON.parse(config.visualizaEixosIds || '[]').includes(
                  props.item.eixoId
                ))
            "
          >
            <v-btn
              v-if="
                isFullAdmin ||
                (groupsConfig.enviarRespondidas && config.enviarRespondidas)
              "
              color="primary"
              class="ml-3"
              @click="sendEvidences(props.item)"
            >
              <span>Enviar</span>
            </v-btn>
          </template>
        </td>
        <td v-if="props.item.evidencia && props.item.evidenciada === false">
          <app-modal-show-evidence
            :evidence="props.item.evidencia"
            :color="'primary'"
            v-if="props.item.evidencia.length > 0"
          >
          </app-modal-show-evidence>
        </td>
        <td v-else></td>
      </tr>
    </template>
    <template slot="no-data">
      <span> Nenhuma pergunta retornada </span>
    </template>
  </v-data-table>
  <respondidas-selo
    v-else
    :visualizarPontosMedalha="visualizarPontosMedalha"
    :headers="headers"
    :headersSemPontos="headersSemPontos"
    :perguntasRespondidas="perguntasRespondidas"
    :payload="payload"
    :expanded="expanded"
    :rulesArquivo="rules"
    :evidences="evidences"
    @sendEvidences="sendEvidences"
    @openEvidence="openEvidence"
    @load="loadEvidences"
    @enviarAnalise="(e) => sendEvidences(e, true)"
  ></respondidas-selo>
</template>

<script>
import { cityQuestionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppModalShowEvidence from "@/modules/diagnostic/components//ModalShowEvidence";
import { sortArrayAsc } from "../../../../helpers/utils";
import RespondidasSelo from "./selo/RespondidasSelo.vue";
import Swal from "sweetalert2";

export default {
  components: {
    AppModalShowEvidence,
    RespondidasSelo,
  },
  data() {
    return {
      rules: [
        (files) => {
          if (files && Array.isArray(files)) {
            var somaTotal = files.reduce((a, b) => {
              return a + b.size;
            }, 0);

            return somaTotal > 26214400
              ? "Total de arquivos não pode ser maior que 25MB!"
              : true;
          } else if (files && !Array.isArray(files)) {
            return files.size > 26214400
              ? "Arquivo não pode ser maior que 25MB!"
              : true;
          }

          return !files;
        },
      ],
      headers: [
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Número", value: "pergunta.numero" },
        { text: "Texto", value: "pergunta.texto" },
        {
          text: "Pontos",
          value: "pergunta.pontos",
        },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "pergunta.evidencia" },
      ],
      headersSemPontos: [
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Número", value: "pergunta.numero" },
        { text: "Texto", value: "pergunta.texto" },
        { text: "", value: "" },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "pergunta.evidencia" },
      ],
      payload: {},
      municipioId: this.$route.params.id,
      perguntasRespondidas: [],
      allPerguntas: [],
      user: JSON.parse(localStorage.getItem("user")),
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      expanded: [],
      evidences: [],
    };
  },
  props: {
    filter: { type: Object, default: () => ({}) },
    visualizarPontosMedalha: false,
  },
  watch: {
    filter: {
      handler(val, oldVal) {
        if (val.temas.length)
          this.perguntasRespondidas = this.allPerguntas.filter((pa) =>
            val.temas.some((te) => te.nome === pa.nome)
          );
        else this.perguntasRespondidas = this.allPerguntas;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
    ]),
    async loadAnsweredQuestions(question) {
      this.setLoading(true);
      cityQuestionAPI
        .getRespondidas(this.municipioId)
        .then(async (resp) => {
          console.log("resp: ", resp);
          this.perguntasRespondidas = resp.data.sort((a, b) => {
            return (
              sortArrayAsc(a.nome, b.nome) || sortArrayAsc(a.texto, b.texto)
            );
          });

          if (!this.user.grupo.verTodosEixos) {
            this.perguntasRespondidas = this.perguntasRespondidas.filter(
              (item) =>
                this.user.permissoes.some(
                  (per) =>
                    per.eixoId === item.eixoId &&
                    per.municipioId === item.municipioId
                )
            );
          }

          this.allPerguntas = this.perguntasRespondidas;

          if (this.filter.temas.length > 0) {
            this.perguntasRespondidas = this.allPerguntas.filter((pa) =>
              this.filter.temas.some((te) => te.nome === pa.nome)
            );
          }

          if (question) {
            this.openEvidence(question, true);
          } else {
            this.setLoading(false);
          }
        })
        .catch((er) => {
          console.log("Erro ao listas perguntas respondidas: ", er);
          this.setLoading(false);
          this.$notification.error("Erro ao obter perguntas");
        });
    },
    check(arquivos) {
      if (arquivos) {
        var somaTotal = arquivos.reduce((a, b) => {
          return a + b.size;
        }, 0);

        return somaTotal > 26214400 ? false : true;
      }

      return true;
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      });
    },
    async sendEvidences(question, analise) {
      if (!this.isSala) {
        const valid = this.check(question.arquivos);
        if (!valid) return;
      }
      const dadosComple = question.perguntaId == 3;

      if (this.isSala) {
        if (
          !question.arquivosDados &&
          !question.arquivos &&
          !analise &&
          dadosComple
        ) {
          this.salvarDadosComplementares(question, analise);
          return;
        }
      }
      if (!question.arquivos && !this.isSala) {
        this.$notification.error("Não há evidências a serem enviadas!");
      } else {
        this.setLoading(true);

        let formData = new FormData();

        if (Array.isArray(question.arquivos)) {
          if (question.arquivos && question.arquivos.length) {
            for (let i = 0; i < question.arquivos.length; i++) {
              formData.append("arquivos", question.arquivos[i]);
            }
          }
        } else if (question.arquivos) {
          formData.append("arquivos", question.arquivos);
        }

        if (question.arquivosDados) {
          question.arquivosDados = this.renameFile(
            question.arquivosDados,
            "DADOS_COMPLE_" + question.arquivosDados.name
          );

          formData.append("arquivos", question.arquivosDados);
        }

        formData.append("perguntaMunicipioId", question.perguntaMunicipioId);
        cityQuestionAPI
          .salvarEvidencias(formData)
          .then((resp) => {
            this.$notification.success("Evidência salva com sucesso");
            if (this.isSala) {
              console.log("aqui4");
              this.salvarDadosComplementares(question, analise);
            } else this.loadAnsweredQuestions();
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao salvar evidência");
          });
      }
    },
    salvarDadosComplementares(pergunta, analise) {
      this.setLoading(true);
      delete pergunta.arquivos;
      delete pergunta.arquivosDados;
      pergunta.salvo = true;
      if (analise) pergunta.evidenciada = true;
      cityQuestionAPI
        .put(pergunta)
        .then((resp) => {
          this.loadAnsweredQuestions(analise ? null : pergunta);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao salvar Pergunta");
        });
    },
    openEvidence(evidenceSlot, deixarAberto) {
      if (this.expanded.length > 0) {
        this.expanded.forEach((item, index) => {
          if (item === evidenceSlot && !deixarAberto) {
            this.expanded.splice(index, 1);
          } else {
            this.expanded = [];
            this.expanded.push(evidenceSlot);
          }
        });
      } else {
        this.expanded.push(evidenceSlot);
      }

      if (this.expanded.length > 0) {
        this.setLoading(true);
        cityQuestionAPI
          .getPergunta(this.expanded[0].perguntaMunicipioId)
          .then((resp) => {
            this.evidences = resp.data.evidencias;
            this.setLoading(false);
          })
          .catch(() => {
            this.setLoading(false);
            this.$notification.error("Erro ao obter pergunta");
          });
      } else {
        this.setLoading(false);
      }
    },
    loadEvidences() {
      this.setLoading(true);
      cityQuestionAPI
        .getPergunta(this.expanded[0].perguntaMunicipioId)
        .then((resp) => {
          this.evidences = resp.data.evidencias;
          this.loadAnsweredQuestions();
        })
        .catch(() => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
  },

  mounted() {
    this.loadAnsweredQuestions();
    if (this.isSala) {
      this.headers = [
        { text: "Pilar", value: "pergunta.tema.nome" },
        { text: "Critério", value: "pergunta.texto" },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "pergunta.evidencia" },
        { text: "", value: "" },
      ];

      this.headersSemPontos = [
        { text: "Pilar", value: "pergunta.tema.nome" },
        { text: "Critério", value: "pergunta.texto" },
        { text: "", value: "" },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "pergunta.evidencia" },
        { text: "", value: "" },
      ];
    } else {
      this.headers = [
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Número", value: "pergunta.numero" },
        { text: "Texto", value: "pergunta.texto" },
        {
          text: "Pontos",
          value: "pergunta.pontos",
        },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "pergunta.evidencia" },
      ];
    }
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "logo",
      "isSala",
      "isAnalista",
      "isFullAdmin",
      "isParceiro",
    ]),
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.p-0 {
  padding: 0 !important;
}
.hasEvidence {
  background: url("/assets/img/certo1.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}
.hasNoEvidence {
  background: url("/assets/img/noEvidence.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}
.semStatus {
  background: url("/assets/img/search.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}

.optionsExpanded {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.openExpanded {
  background: url("/assets/img/right-arrow.png") no-repeat;
  width: 20px;
  height: 20px;
  transform: rotate(90deg);
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
  float: right;
}
.expandedClass {
  transform: rotate(270deg);
}
</style>
